import GameBtfd from './assets/game-btfd.png';
import GameCandyDefence from './assets/game-candydefence.png';
import GameChooChoo from './assets/game-choochoo.png';
import GameEVM from './assets/game-evm.png';
import GameKittySlash from './assets/game-kittyslash.png';
import GamePepeKingdom from './assets/game-pepekingdom.png';
import GameSugarRush from './assets/game-sugarrush.png';
import GameZookQuest from './assets/game-zookquest.webp';
import Lootbox1 from './assets/lootbox-1.webp';
import Lootbox2 from './assets/lootbox-2.webp';
import Lootbox3 from './assets/lootbox-3.webp';
import Lootbox4 from './assets/lootbox-4.webp';
import Lootbox5 from './assets/lootbox-5.webp';
import Lootbox6 from './assets/lootbox-6.webp';
import Lootbox7 from './assets/lootbox-7.webp';
import Lootbox8 from './assets/lootbox-8.webp';
import Avatar from './assets/avatar.png';
import ZCToken from './assets/zc-token.png';
import DappBridge from './assets/dapp-bridge.webp';
import DappDex from './assets/dapp-dex.webp';

export const ecosystemData = {
  games: [
    {
      id: 1,
      image: GameChooChoo,
      name: 'Choo Choo Spirit',
      link: 'https://choochoospirits.io/',
    },
    {
      id: 2,
      image: GameBtfd,
      name: 'BTFD',
      link: 'https://btfd.agency/',
    },
    {
      id: 3,
      image: GameEVM,
      name: 'EVM',
      link: 'https://evmwarfare.xyz/',
    },
    {
      id: 4,
      image: GameSugarRush,
      name: 'Sugar Rush',
      link: 'https://sugarrush-testnet.zkcandy.io/',
    },
    {
      id: 5,
      image: GamePepeKingdom,
      name: 'Pepe Kingdom',
      link: 'https://app.pepekingdom.wtf/',
    },
    {
      id: 6,
      image: GameCandyDefence,
      name: 'Candy Defence',
      link: 'https://app.candydefense.xyz/',
    },
    {
      id: 7,
      image: GameKittySlash,
      name: 'Kitty Slash',
      // link: 'https://app.kittyslash.com/',
    },
    {
      id: 8,
      image: GameZookQuest,
      name: 'Zook Quest',
      link: 'https://t.me/zooksquestbot',
    },
  ],
  dapps: [
    {
      id: 1,
      name: "Bridge",
      description: "",
      image: DappBridge,
      link: "https://bridge.zkcandy.io/"
    },
    {
      id: 2,
      name: "DEX",
      description: "",
      image: DappDex,
      link: "https://app.dodoex.io/swap/network/zkcandy"
    },
  ]
};

export const questsData = {
  socialfi: [
    {
      id: 1,
      title: "Twitter Champion",
      description: "Follow ZKcandy and retweet our latest announcement",
      reward: "100 $CANDY",
      completed: false,
      type: "social",
      difficulty: "Easy"
    },
    {
      id: 2,
      title: "Discord Engagement",
      description: "Join our Discord and participate in community discussion",
      reward: "150 $CANDY",
      completed: true,
      type: "social",
      difficulty: "Easy"
    },
    {
      id: 3,
      title: "Content Creator",
      description: "Create a video about ZKcandy ecosystem",
      reward: "1000 $CANDY",
      completed: false,
      type: "social",
      difficulty: "Hard"
    }
  ],
  gaming: [
    {
      id: 4,
      title: "CryptoRacer Rookie",
      description: "Complete 5 races in CryptoRacer",
      reward: "200 $CANDY + Racing NFT",
      completed: false,
      type: "game",
      difficulty: "Medium"
    },
    {
      id: 5,
      title: "ZK Warrior Master",
      description: "Win 3 battles in ZK Warriors",
      reward: "300 $CANDY",
      completed: true,
      type: "game",
      difficulty: "Medium"
    },
    {
      id: 6,
      title: "Meta Farmer Expert",
      description: "Harvest 100 rare crops",
      reward: "500 $CANDY + Rare Seed NFT",
      completed: false,
      type: "game",
      difficulty: "Hard"
    }
  ]
};

export const lootboxData = [
  {
    id: 1,
    name: "Mystic Vault",
    description: "Perfect for beginners. Contains common items and small amount of $CANDY",
    image: Lootbox1,
    price: "50 USDT",
    rarity: "Common",
    contents: ["Common NFT", "100-500 $CANDY", "1 Game Ticket"]
  },
  {
    id: 2,
    name: "Epic Cache",
    description: "Higher chance for rare items and exclusive game assets",
    image: Lootbox2,
    price: "100 USDT",
    rarity: "Rare",
    contents: ["Rare NFT", "500-1000 $CANDY", "3 Game Tickets"]
  },
  {
    id: 3,
    name: "Treasure Trove",
    description: "Guaranteed legendary item and massive $CANDY rewards",
    image: Lootbox3,
    price: "500 USDT",
    rarity: "Legendary",
    contents: ["Legendary NFT", "2000-5000 $CANDY", "10 Game Tickets"]
  },
  {
    id: 4,
    name: "Arcane Crate",
    description: "Limited edition box with exclusive items",
    image: Lootbox4,
    price: "200 USDT",
    rarity: "Mystery",
    contents: ["Mystery NFT", "???"]
  },
  {
    id: 5,
    name: "Shadow Box",
    description: "Perfect for beginners. Contains common items and small amount of $CANDY",
    image: Lootbox5,
    price: "50 USDT",
    rarity: "Common",
    contents: ["Common NFT", "100-500 $CANDY", "1 Game Ticket"]
  },
  {
    id: 6,
    name: "Phantom Chest",
    description: "Higher chance for rare items and exclusive game assets",
    image: Lootbox6,
    price: "100 USDT",
    rarity: "Rare",
    contents: ["Rare NFT", "500-1000 $CANDY", "3 Game Tickets"]
  },
  {
    id: 7,
    name: "Radiant Stash",
    description: "Guaranteed legendary item and massive $CANDY rewards",
    image: Lootbox7,
    price: "500 USDT",
    rarity: "Legendary",
    contents: ["Legendary NFT", "2000-5000 $CANDY", "10 Game Tickets"]
  },
  {
    id: 8,
    name: "Legendary Lockbox",
    description: "Limited edition box with exclusive items",
    image: Lootbox8,
    price: "200 USDT",
    rarity: "Mystery",
    contents: ["Mystery NFT", "???"]
  }
];

export const walletMockData = {
  walletAddr: "0xC7e53Be805f13d5E40D9c07E5aFb30A7923a787F",
  passportID: '#12345',
  balance: 0.1234,
  tokens: [
    {
      id: 1,
      symbol: "CANDY",
      name: "ZKcandy Token",
      balance: "1,234.56",
      value: "2,469.12",
      icon: ZCToken
    }
  ],
  nfts: [
    {
      id: 1,
      name: "Mystic Vault",
      description: "Perfect for beginners. Contains common items and small amount of $CANDY",
      image: Lootbox1,
      price: "50 USDT",
      rarity: "Common",
      contents: ["Common NFT", "100-500 $CANDY", "1 Game Ticket"]
    },
    {
      id: 2,
      name: "Epic Cache",
      description: "Higher chance for rare items and exclusive game assets",
      image: Lootbox2,
      price: "100 USDT",
      rarity: "Rare",
      contents: ["Rare NFT", "500-1000 $CANDY", "3 Game Tickets"]
    },
    {
      id: 3,
      name: "Treasure Trove",
      description: "Guaranteed legendary item and massive $CANDY rewards",
      image: Lootbox3,
      price: "500 USDT",
      rarity: "Legendary",
      contents: ["Legendary NFT", "2000-5000 $CANDY", "10 Game Tickets"]
    },
    {
      id: 4,
      name: "Arcane Crate",
      description: "Limited edition box with exclusive items",
      image: Lootbox4,
      price: "200 USDT",
      rarity: "Mystery",
      contents: ["Mystery NFT", "???"]
    },
  ]
};  

export const userProfileData = {  
  id: "user123",  
  username: "CryptoChampion",  
  points: 12500,  
  rank: 42,  
  level: 25,  
  avatar: Avatar,  
  achievements: [  
    {  
      id: 1,  
      name: "Early Adopter",  
      icon: "🌟",  
      description: "Joined during beta phase"  
    },  
    {  
      id: 2,  
      name: "Quest Master",  
      icon: "🏆",  
      description: "Completed 100 quests"  
    },  
    {  
      id: 3,  
      name: "Social Butterfly",  
      icon: "🦋",  
      description: "Connected all social accounts"  
    }  
  ]  
};  
  
export const leaderboardData = {  
  global: [  
    {  
      id: "user1",  
      username: "CryptoKing",  
      points: 45000,  
      avatar: "https://picsum.photos/200/200?random=20",  
      rank: 1,  
      level: 50  
    },  
    {  
      id: "user2",  
      username: "NFTQueen",  
      points: 42000,  
      avatar: "https://picsum.photos/200/200?random=21",  
      rank: 2,  
      level: 48  
    },  
    {  
      id: "user3",  
      username: "GameMaster",  
      points: 40000,  
      avatar: "https://picsum.photos/200/200?random=22",  
      rank: 3,  
      level: 47  
    },  
    // Add more users...  
  ],  
  weekly: [  
    {  
      id: "user5",  
      username: "WeeklyHero",  
      points: 15000,  
      avatar: "https://picsum.photos/200/200?random=23",  
      rank: 1,  
      level: 35  
    },  
    {  
      id: "user6",  
      username: "QuestPro",  
      points: 14500,  
      avatar: "https://picsum.photos/200/200?random=24",  
      rank: 2,  
      level: 33  
    },  
    {  
      id: "user7",  
      username: "ZKWarrior",  
      points: 13800,  
      avatar: "https://picsum.photos/200/200?random=25",  
      rank: 3,  
      level: 31  
    },  
    // Add more users...  
  ]  
};  